import { graphql, useStaticQuery } from "gatsby";

import { useGviconfigurator } from "./useSiteConfigurator";

export const useBannerManager = (slug = null) => {
  const { wp } = useStaticQuery(graphql`
    {
      wp {
        acfOptionsBannerManager {
          BannerManager {
            generic: gvibmGenericBannerList {
              title: gvibmGenericBannerTitle
              image: gvibmGenericBannerImage {
                ...homepageIssuesImagesFragment
              }
            }
            bannerlist: gvibmBannerList {
              title: gvibmBannerTitle
              image: gvibmBannerImage {
                ...homepageIssuesImagesFragment
              }
              pagelist: gvibmPageList {
                ... on WpPage {
                  slug
                }
                ... on WpLocationPage {
                  slug
                }
              }
            }
          }
        }
      }
    }
  `);

  const genericBanner = wp?.acfOptionsBannerManager?.BannerManager?.generic[0];

  if (slug) {
    const bannerList =
      wp?.acfOptionsBannerManager?.BannerManager?.bannerlist ?? [];
    const banner = bannerList.find((b) =>
      b?.pagelist?.some((p) => p?.slug === slug)
    );

    if (banner) {
      return banner;
    }
  }

  return genericBanner;
};

export const useBannerDetails = (slug = null, source = "sidebar") => {
  const configurator = useGviconfigurator();
  const { grants_banner_config } = configurator ?? {};

  const grantsConfigDetails =
    grants_banner_config[source] ?? grants_banner_config?.dates ?? {};

  const banner = useBannerManager(slug);

  const defaultPlaceholderTitle =
    process.env.GATSBY_DEFAULT_THEME === "light"
      ? "community programs"
      : "conservation programs";

  return {
    ...banner,
    title:
      grantsConfigDetails?.title.replaceAll(
        "SHORTCODE_BannerTitle",
        banner?.title || defaultPlaceholderTitle
      ) ?? "",
    desc:
      grantsConfigDetails?.desc.replaceAll(
        "SHORTCODE_BannerTitle",
        banner?.title || defaultPlaceholderTitle
      ) ?? ""
  };
};